import React, { VFC } from 'react';
import T from 'i18n-react';
import { useTheme } from '@material-ui/core/styles';
import HistoryIcon from '@material-ui/icons/History';
import Styled from '../Styled';
import IconWithWord from './MuiIconWithWord';

// js codes
import { USER_HISTORIES } from '../../../routing';

const { IconWrapper, IconLink } = Styled;

interface Props {}
const UserHistoryIconLink: VFC<Props> = (props: Props) => {
  const theme = useTheme();
  return (
    <IconWrapper theme={theme}>
      <IconLink href={USER_HISTORIES}>
        <IconWithWord
          Icon={HistoryIcon}
          word={T.translate('header.menu.histories')}
        />
      </IconLink>
    </IconWrapper>
  );
};

export default UserHistoryIconLink;
